/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_BackInputs */

const en_us2_intake_back = /** @type {(inputs: Intake_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous question`)
};

const pt_br2_intake_back = /** @type {(inputs: Intake_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunta anterior`)
};

const es_419_intake_back = /** @type {(inputs: Intake_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunta anterior`)
};

const pt_pt2_intake_back = /** @type {(inputs: Intake_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunta anterior`)
};

const fr_fr2_intake_back = /** @type {(inputs: Intake_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question précédente`)
};

const de_de2_intake_back = /** @type {(inputs: Intake_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Frage`)
};

const it_it2_intake_back = /** @type {(inputs: Intake_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domanda precedente`)
};

/**
* | output |
* | --- |
* | "Previous question" |
*
* @param {Intake_BackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_back = /** @type {((inputs?: Intake_BackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_BackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_back(inputs)
	if (locale === "es-419") return es_419_intake_back(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_back(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_back(inputs)
	if (locale === "de-DE") return de_de2_intake_back(inputs)
	if (locale === "it-IT") return it_it2_intake_back(inputs)
	return en_us2_intake_back(inputs)
});
export { intake_back as "intake.back" }